import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { coerceAtMost1wyvl5p1shiw0 as coerceAtMost } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import {
  Semanticpmpmvt7fldq2 as Semantic,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  DisabledSemantic_getInstanceimdypc22j9b3 as DisabledSemantic_getInstance,
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  EmphasizedSemantic_getInstancev1hnk3pae9tz as EmphasizedSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  DownSemantic_getInstance12o2om5g6786l as DownSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { Constant5dc3leeorpdb as Constant } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function matchBrightness(_this__u8e3s4, other, skew) {
  skew = skew === VOID ? 1.0 : skew;
  // Inline function 'kotlin.let' call
  var it = _this__u8e3s4.rjn();
  return it.q1(numberToInt((it.p1() - 1 | 0) * coerceAtMost(other.bb2().zb2() * skew, 1.0)));
}
function ReviewSelectionSemantic$default$lambda($this$to, it) {
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, matchBrightness(AppColors_getInstance().kfz_1, it.ob0_1, 1.2));
}
function ReviewSelectionSemantic$default$lambda_0($this$to, it) {
  return it.ab1_1;
}
function ReviewSelectionSemantic$default$lambda_1($this$to, it) {
  return it.ab1_1;
}
var ReviewSelectionSemanticClass;
function ReviewSelectionSemantic() {
  if (ReviewSelectionSemanticClass === VOID) {
    class $ extends Semantic() {
      static njp() {
        ReviewSelectionSemantic_instance = null;
        var $this = this.bd1('slc4rvw');
        ReviewSelectionSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = SelectedSemantic_getInstance();
        var tmp_0 = to(tmp, ReviewSelectionSemantic$default$lambda);
        var tmp_1 = DisabledSemantic_getInstance();
        var tmp_2 = to(tmp_1, ReviewSelectionSemantic$default$lambda_0);
        var tmp_3 = UnselectedSemantic_getInstance();
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, tmp_2, to(tmp_3, ReviewSelectionSemantic$default$lambda_1)]));
      }
      toString() {
        return 'ReviewSelectionSemantic';
      }
      hashCode() {
        return -727418232;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ReviewSelectionSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ReviewSelectionSemantic');
    ReviewSelectionSemanticClass = $;
  }
  return ReviewSelectionSemanticClass;
}
var ReviewSelectionSemantic_instance;
function ReviewSelectionSemantic_getInstance() {
  if (ReviewSelectionSemantic_instance === VOID)
    ReviewSelectionSemantic().njp();
  return ReviewSelectionSemantic_instance;
}
function ApprovedSemantic$default$lambda($this$to, it) {
  var green = matchBrightness(AppColors_getInstance().dfz_1, it.ob0_1, 1.1);
  var tmp0_foreground = green.zb2() > 0.5 ? Companion_getInstance().taz_1 : Companion_getInstance().raz_1;
  var tmp1_cornerRadii = new (Constant())(get_AppDimensions().pg2_1);
  return $this$to.hd1(it, VOID, VOID, VOID, tmp1_cornerRadii, VOID, VOID, tmp0_foreground, VOID, VOID, VOID, VOID, green);
}
function ApprovedSemantic$default$lambda_0($this$to, it) {
  return $this$to.ed1(it, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().dfz_1.xg9_1);
}
var ApprovedSemanticClass;
function ApprovedSemantic() {
  if (ApprovedSemanticClass === VOID) {
    class $ extends Semantic() {
      static pjp() {
        ApprovedSemantic_instance = null;
        var $this = this.bd1('aprvd');
        ApprovedSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = CardSemantic_getInstance();
        var tmp_0 = to(tmp, ApprovedSemantic$default$lambda);
        var tmp_1 = EmphasizedSemantic_getInstance();
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, to(tmp_1, ApprovedSemantic$default$lambda_0)]));
      }
      toString() {
        return 'ApprovedSemantic';
      }
      hashCode() {
        return -1745865265;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ApprovedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ApprovedSemantic');
    ApprovedSemanticClass = $;
  }
  return ApprovedSemanticClass;
}
var ApprovedSemantic_instance;
function ApprovedSemantic_getInstance() {
  if (ApprovedSemantic_instance === VOID)
    ApprovedSemantic().pjp();
  return ApprovedSemantic_instance;
}
function DeniedSemantic$default$lambda($this$to, it) {
  var red = matchBrightness(AppColors_getInstance().hfz_1, it.ob0_1);
  var tmp0_foreground = red.zb2() > 0.5 ? Companion_getInstance().taz_1 : Companion_getInstance().raz_1;
  var tmp1_cornerRadii = new (Constant())(get_AppDimensions().pg2_1);
  return $this$to.hd1(it, VOID, VOID, VOID, tmp1_cornerRadii, VOID, VOID, tmp0_foreground, VOID, VOID, VOID, VOID, red);
}
function DeniedSemantic$default$lambda_0($this$to, it) {
  return $this$to.ed1(it, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().hfz_1.xg9_1);
}
var DeniedSemanticClass;
function DeniedSemantic() {
  if (DeniedSemanticClass === VOID) {
    class $ extends Semantic() {
      static rjp() {
        DeniedSemantic_instance = null;
        var $this = this.bd1('dnid');
        DeniedSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = CardSemantic_getInstance();
        var tmp_0 = to(tmp, DeniedSemantic$default$lambda);
        var tmp_1 = EmphasizedSemantic_getInstance();
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, to(tmp_1, DeniedSemantic$default$lambda_0)]));
      }
      toString() {
        return 'DeniedSemantic';
      }
      hashCode() {
        return 1374718771;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeniedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DeniedSemantic');
    DeniedSemanticClass = $;
  }
  return DeniedSemanticClass;
}
var DeniedSemantic_instance;
function DeniedSemantic_getInstance() {
  if (DeniedSemantic_instance === VOID)
    DeniedSemantic().rjp();
  return DeniedSemantic_instance;
}
function ApprovalToggles$default$lambda($this$to, it) {
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, get_rem(0.95));
}
function ApprovalToggles$default$lambda_0($this$to, it) {
  var back = it.ob0_1.bb2();
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, back.equals(Companion_getInstance().raz_1) ? back : AppColors_getInstance().ffz_1.zg9_1.gcz(0.6));
}
function ApprovalToggles$default$lambda_1($this$to, it) {
  var back = it.ob0_1.bb2();
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, back.equals(Companion_getInstance().raz_1) ? back : AppColors_getInstance().ffz_1.zg9_1.gcz(0.8));
}
function ApprovalToggles$default$lambda_2($this$to, approved) {
  var tmp = SelectedSemantic_getInstance();
  var tmp_0 = to(tmp, ApprovalToggles$default$lambda$lambda);
  var tmp_1 = UnselectedSemantic_getInstance();
  return $this$to.ed1(approved, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, to(tmp_1, ApprovalToggles$default$lambda$lambda_0)]));
}
function ApprovalToggles$default$lambda$lambda($this$to, it) {
  var tmp0_foreground = AppColors_getInstance().dfz_1.xg9_1;
  var tmp1_background = it.ob0_1;
  var tmp2_font = it.eb0_1.td4(VOID, VOID, true);
  var tmp3_outline = AppColors_getInstance().ffz_1.zg9_1;
  var tmp4_outlineWidth = get_dp(4);
  return $this$to.hd1(it, VOID, tmp2_font, VOID, VOID, VOID, VOID, tmp0_foreground, VOID, tmp3_outline, tmp4_outlineWidth, VOID, tmp1_background);
}
function ApprovalToggles$default$lambda$lambda_0($this$to, it) {
  var tmp0_foreground = Companion_getInstance().ycy(0.1);
  var tmp1_background = AppColors_getInstance().ffz_1.zg9_1;
  var tmp2_outline = AppColors_getInstance().ffz_1.zg9_1;
  var tmp3_outlineWidth = get_dp(4);
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_foreground, null, tmp2_outline, tmp3_outlineWidth, VOID, tmp1_background);
}
function ApprovalToggles$default$lambda_3($this$to, denied) {
  var tmp = SelectedSemantic_getInstance();
  var tmp_0 = to(tmp, ApprovalToggles$default$lambda$lambda_1);
  var tmp_1 = UnselectedSemantic_getInstance();
  return $this$to.ed1(denied, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, to(tmp_1, ApprovalToggles$default$lambda$lambda_2)]));
}
function ApprovalToggles$default$lambda$lambda_1($this$to, it) {
  var tmp0_foreground = AppColors_getInstance().hfz_1.xg9_1;
  var tmp1_background = it.ob0_1;
  var tmp2_font = it.eb0_1.td4(VOID, VOID, true);
  var tmp3_outline = AppColors_getInstance().ffz_1.zg9_1;
  var tmp4_outlineWidth = get_dp(4);
  return $this$to.hd1(it, VOID, tmp2_font, VOID, VOID, VOID, VOID, tmp0_foreground, VOID, tmp3_outline, tmp4_outlineWidth, VOID, tmp1_background);
}
function ApprovalToggles$default$lambda$lambda_2($this$to, it) {
  var tmp0_foreground = Companion_getInstance().ycy(0.1);
  var tmp1_background = AppColors_getInstance().ffz_1.zg9_1;
  var tmp2_outline = AppColors_getInstance().ffz_1.zg9_1;
  var tmp3_outlineWidth = get_dp(4);
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_foreground, null, tmp2_outline, tmp3_outlineWidth, VOID, tmp1_background);
}
var ApprovalTogglesClass;
function ApprovalToggles() {
  if (ApprovalTogglesClass === VOID) {
    class $ extends Semantic() {
      static tjp() {
        ApprovalToggles_instance = null;
        var $this = this.bd1('apvltgl');
        ApprovalToggles_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = ButtonSemantic_getInstance();
        var tmp_0 = to(tmp, ApprovalToggles$default$lambda);
        var tmp_1 = HoverSemantic_getInstance();
        var tmp_2 = to(tmp_1, ApprovalToggles$default$lambda_0);
        var tmp_3 = DownSemantic_getInstance();
        var tmp_4 = to(tmp_3, ApprovalToggles$default$lambda_1);
        var tmp_5 = ApprovedSemantic_getInstance();
        var tmp_6 = to(tmp_5, ApprovalToggles$default$lambda_2);
        var tmp_7 = DeniedSemantic_getInstance();
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, tmp_2, tmp_4, tmp_6, to(tmp_7, ApprovalToggles$default$lambda_3)]));
      }
      toString() {
        return 'ApprovalToggles';
      }
      hashCode() {
        return -1822823062;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ApprovalToggles()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ApprovalToggles');
    ApprovalTogglesClass = $;
  }
  return ApprovalTogglesClass;
}
var ApprovalToggles_instance;
function ApprovalToggles_getInstance() {
  if (ApprovalToggles_instance === VOID)
    ApprovalToggles().tjp();
  return ApprovalToggles_instance;
}
//region block: exports
export {
  ApprovalToggles_getInstance as ApprovalToggles_getInstance35u0pxe4sacct,
  ApprovedSemantic_getInstance as ApprovedSemantic_getInstance10vizqzbc90jx,
  DeniedSemantic_getInstance as DeniedSemantic_getInstanceb7su0ait1it4,
  ReviewSelectionSemantic_getInstance as ReviewSelectionSemantic_getInstance79bht8dtdj2a,
};
//endregion

//# sourceMappingURL=approval.mjs.map
